// Course
export const GET_MYCOURSES_SUCCESS = 'GET_MYCOURSES_SUCCESS';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';

// Alert
export const ALERT_WITH_MESSAGE = 'ALERT_WITH_MESSAGE';
export const ALERT_HIDE = 'ALERT_HIDE';

//MSG
export const MSG_CHANGED = 'MSG_CHANGED';
export const OPEN_CHATGROUP = 'OPEN_CHATGROUP';
export const MESSAGE_RECEIVE = 'MESSAGE_RECEIVE';
export const CVST_CHANGED = 'CVST_CHANGED';
export const REFRESH_MSG = 'REFRESH_MSG';
export const REFRESH_NOTI = 'REFRESH_NOTI';
export const REFRESH_SIDEBAR = 'REFRESH_SIDEBAR';

//ZOOM
export const ZOOM_MSG = 'ZOOM_MSG';



/** WEBPACK FOOTER **
 ** ./src/client/app/actions/action-types.js
 **/